import React, {Component} from 'react';
import MatchWhenLoggedIn from './../MatchWhenLoggedIn';
import {Route, Redirect} from 'react-router-dom';
import MovimentiList from './MovimentiList'
import MovimentiView from './MovimentiView'
import MovimentiForm from './MovimentiForm'

class MovimentiContent extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (<div>
      <Route exact path='/app/movimenti' render={() => (
          <Redirect
              to='/app/movimenti/list'
          />
      )} />
      <MatchWhenLoggedIn path='/app/movimenti/list' component={MovimentiList}/>
      <MatchWhenLoggedIn path='/app/movimenti/view/:id' component={MovimentiView} />
      <MatchWhenLoggedIn path='/app/movimenti/edit/:id' component={MovimentiForm} />
      <MatchWhenLoggedIn path='/app/movimenti/new' component={MovimentiForm} />

    </div>)
  }
}

export default MovimentiContent;




/** WEBPACK FOOTER **
 ** ./src/components/movimenti/MovimentiContent.js
 **/